import { PopupMenuItem } from '$common/popup-menu'
import { ClearHistoryIcon } from '$common/icons/clear-history'
import { RemoveChatIcon } from '$common/icons/remove-chat'
import { ContextMenuList } from '$comp/_app/components/chat/components/body/components/context-menu/components'
import {
  showClearWappRoomHistory,
  showDeleteWappRoomModal,
} from '$comp/modals/confirmation-dialog'
import { t } from '$i18n'

export function WappProfileMenu({
  onClose,
  yAxis,
  xAxis,
  wappId,
}: {
  onClose: () => unknown
  xAxis: number
  yAxis: number
  wappId: string
}) {
  return (
    <ContextMenuList onClose={onClose} open xAxis={xAxis} yAxis={yAxis}>
      <PopupMenuItem
        text={t('menu.common.removeChat')}
        onClick={() => {
          onClose()
          showDeleteWappRoomModal(wappId)
        }}
      >
        <RemoveChatIcon />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.common.clearHistory')}
        onClick={() => {
          onClose()
          showClearWappRoomHistory(wappId)
        }}
      >
        <ClearHistoryIcon />
      </PopupMenuItem>
    </ContextMenuList>
  )
}
